module.exports = __webpack_public_path__ + "static/media/icebg.1a5b42ae.jpg";